import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  dashboard: () => __(translations.accountPage.dashboard, 'Dashboard'),
  pageTitle: () => __(translations.accountPage.pageTitle, 'Account'),
  select: () => __(translations.accountPage.select, 'Select'),
  imagePickerInstructions: () => __(translations.accountPage.imagePickerInstructions, 'Allowed JPG, GIF or PNG. Max size of 800kB'),
};
